import type { ConceptDef } from '../types';

export const mandBreak: ConceptDef = {
  kind: 'supervisorScored',
  id: 'mand-break',
  label: 'Mand Break',
  category: 'Mand',
  description: 'After work, learner requests a break. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: 'After 5 minutes of work.', hint: 'Expect: "Break please."' },
      { prompt: 'During a challenging task.' },
      { prompt: 'When learner looks tired.' },
      { prompt: 'Before a longer activity.' },
    ],
  },
};
